import { createStore } from 'little-state-machine';

import './types';

createStore({
  newCoachForm: {},
  board: {
    statusHovered: undefined,
  },
});
